module.exports = __webpack_public_path__ + "static/media/service1.fc3ce07a.png";